module.exports = __webpack_public_path__ + "img/Rectangle4348.fa173200.png";